import { API_URL } from "../../../../utils/config";

export const GET_INCIDENT_REPORTS_URL = `${API_URL}/incidentReport/getReports`;
export const ADD_INCIDENT_REPORT_URL = `${API_URL}/incidentReport/addreports`;
export const GET_INCIDENT_REPORTS_BY_DATE_URL = `${API_URL}/incidentReport/getReportsByDate/1`;
